import React from "react";

function InventoryTable({ products = [], loading }) {
  return (
    <div className="table-wrapper">
      <table className="product-table">
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Weight/Amount</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4">Loading...</td>
            </tr>
          ) : products.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-center">
                No inventory found
              </td>
            </tr>
          ) : (
            products.map((product) => (
              <tr key={product._id}>
                <td>{product.name}</td>
                <td>{product.qty}</td>
                <td>{product.weight}</td>
                <td>{product.category}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default InventoryTable;
